import { render, staticRenderFns } from "./TheDirectionIcon.vue?vue&type=template&id=f8239f10&"
import script from "./TheDirectionIcon.vue?vue&type=script&lang=js&"
export * from "./TheDirectionIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports